const Q = require(`q`);
const _ = require(`underscore`);
const to_boolean = require(`nllib/src/convert/to_boolean`);
const __request = require(`./__request/__request_contentType_json`);

// 接口文档地址：
// https://www.apifox.cn/apidoc/shared-1d26017f-9316-400b-af24-2c18196c28be/api-31056097
const web_wallet_buyer_recharge_getPayChannel = (pParameter) => {
    if (!pParameter) pParameter = {};
    const companyId = pParameter.companyId || ``;
    const isUseCredit = (pParameter.isUseCredit === undefined || pParameter.isUseCredit === null) ? 1 : pParameter.isUseCredit;
    const payAmount = pParameter.payAmount || 0;
    const type = pParameter.type || 1;//获取类型：1.支付，2.授信还款，3.胤钱宝充值
    const clientType = pParameter.clientType || 1;//客户端类型：1.b2b，2.b2c，3.差旅,默认为1

    const p = {
        method: 'post',
        urlSuffix: '/web/wallet/buyer/recharge/getPayChannel',
        data: {
            companyId,
            isUseCredit,
            payAmount,
            type,
            clientType,
        },
    };
    return Q.when()
        .then(function () {
            return __request(p);
        })
        .then(function (data) {
            const paymentChannels = data.paymentChannels;
            if (!_.isArray(paymentChannels)) {
                const msg = 'web_wallet_buyer_recharge_getPayChannel parameter error, code=001';
                console.error(msg);
                return Q.reject({msg: msg});
            }

            return Q.resolve(data);
        })
        .catch(function (ex) {
            console.error(ex);
            if (ex) {
                if (ex.stack) {
                    console.error(ex.stack);
                }
            }
            return Q.reject(ex);
        })
        ;
};
module.exports = web_wallet_buyer_recharge_getPayChannel;
